import { AddTreatmentResponseDto } from "@/data/dto/treatment-source/add-treatment-response-dto";
import { AddTreatmentResponseEntity } from "@/domain/entity/treatment/add-treatment-response-entity";
import { assertAddTreatmentResponseDto } from "@/utils/validation/generated/add-treatment-response-dto.validator";

export class AddTreatmentResponseInfoMapper {
  static toEntity(dto: AddTreatmentResponseDto): AddTreatmentResponseEntity {
    assertAddTreatmentResponseDto(dto);

    return {
      newTreatmentUuid: dto.newTreatmentUuid,
      terminatedTreatmentUuid: dto.terminatedTreatmentUuid ?? "",
    };
  }
}
